export const sendHeightToIframe = (current) => {
    const sendHeight = () => {
        const scrollHeight = current?.clientHeight + 100;
        const height = scrollHeight;
        window.parent.postMessage(
            { type: 'privacy_whitefact_iframe_height', height },
            '*'
        );
    };
    window.addEventListener('resize', sendHeight);
    return sendHeight();
};

export const sendHeightToIframeConsent = (current) => {
    const sendHeight = () => {
        const scrollHeight = current?.clientHeight + 100;
        const height = scrollHeight;
        window.parent.postMessage(
            { type: 'template_design_iframe_height', height },
            '*'
        );
    };
    window.addEventListener('resize', sendHeight);
    return sendHeight();
};
